import { NEWS_LETTER_BLOCK_ID, GALLARY_EXPLORE_BLOCK_ID, CONTACT_US_BLOCK_ID, SOCIAL_MEDIA_BLOCK_ID, CONTACT_US, SUPPORT, SITE_MAP, PRIVACY_POLICY, TERMS_CONDITION, TERMS_OF_USE, GIVEPLEASE_MICROSITE,HEADER_BLOCK_ID  } from "../../common/constant";
import React, { Suspense, lazy } from 'react';
import { IMG_LOGO, COMPANY_NAME_FULL } from '../../common/';
import FleckringFooter from './fleckring-footer';
import PageContext from '../../context';
import { history } from "../../jwt/_helpers";
import { Common } from "../../common/common";
import moment from "moment";
import { LOGO_GIVEPLEASE } from "../../assets/images/icon-svg";
const ImageLoader = lazy(() => import('../../common/image-loader'));


class FooterSection extends React.Component {
    static contextType = PageContext;
    constructor(props) {
        super(props);
        this.state = {
            conactDetails: null,
            newsLetterSettings: null,
            settings: [],
            gallaryBlock: null,
            gallarySetting: null,
            contactUsBlock: null,
            socialMediaBlock: null,
            socialMediaIcon: null,
            isHeaderMenu:false,
            year: moment().format('YYYY')
        };
    }

    componentDidMount() {
        const context = this.context;

        const contactBlock = context.blockDetails.filter((details) => details.blockId === CONTACT_US_BLOCK_ID);
        const socialMediaBlock = context.blockDetails.filter((details) => details.blockId === SOCIAL_MEDIA_BLOCK_ID);
        const headerBlock = context.blockDetails.find((block) => block.blockId === HEADER_BLOCK_ID)
        const headerMenusIsVisible = headerBlock.settings.find(setting => setting.settingId === 2)?.isVisible;
        console.log(headerMenusIsVisible, 'headerBlock')

        this.setState({
            conactDetails: context.conactDetails ?? null,
            contactUsBlock: contactBlock[0],
            socialMediaBlock: socialMediaBlock[0],
            socialMediaIcon: context.socialMediaIcon,
            isHeaderMenu: headerMenusIsVisible
        })
    }

    render() {
        console.log(this.state.socialMediaIcon, 'socialMediaIcon')
        return (
            <>
                {
                    this.state?.conactDetails && this.state?.socialMediaIcon.length ?
                        <div id="CONTACT" className="sec-footer">
                            <div className="container">
                                {this.state.socialMediaBlock?.isEnabled ?
                                    <div className="row c-contact-social">
                                        <div className="col-12 col-md-11 c-contact">
                                            {this.state.conactDetails.contactNumber ?
                                                <a href={"tel:" + (this.state.conactDetails.contactNumber)} target="_blank" title="Phone Number">
                                                    <Suspense fallback={null}>
                                                        <ImageLoader type="image" src="/images/contact/tel.svg"></ImageLoader>
                                                    </Suspense>
                                                    <span>{this.state.conactDetails.contactNumber}</span>
                                                </a> : null
                                            }
                                            {this.state.conactDetails.contactEmail ?
                                                <a href={"mailto:" + (this.state.conactDetails.contactEmail)} target="_blank" title="Email Address">
                                                    <Suspense fallback={null}>
                                                        <ImageLoader type="image" src="/images/contact/email.svg"></ImageLoader>
                                                    </Suspense>
                                                    <span>{this.state.conactDetails.contactEmail}</span>
                                                </a> : null
                                            }
                                            {this.state.conactDetails.contactAddress ?
                                                <a href={"https://maps.google.com/maps?q=" + (encodeURIComponent(this.state.conactDetails.contactAddress))} target="_blank" title="Address">
                                                    <Suspense fallback={null}>
                                                        <ImageLoader type="image" src="/images/contact/address.svg"></ImageLoader>
                                                    </Suspense>
                                                    <span>{this.state.conactDetails.contactAddress}</span>
                                                </a> : null
                                            }
                                        </div>
                                        <div className="col-12 col-md-1 c-social">

  {/* add headermenu condition here bcz if we are not showing headermenu in header section then it means
   we are showing socialmedia icon there like kdf and deck, then in that case we will not show socialMedia icon in footer */}
                                          
                                                {
                                                    this.state.isHeaderMenu && (

                                                        this.state.socialMediaIcon.map((social, index) => {
                                                            return social.socialMediaIconUrl && social.socialMediaIconName && <a href={social.socialMediaIconUrl} target="_blank" title={social.socialMediaIconName} key={index}>
                                                                <Suspense fallback={null}>
                                                                    <ImageLoader type="image" src={"/images/social/" + social.socialMediaIconName.replace(' ', '').toLowerCase() + ".png"}></ImageLoader>
                                                                </Suspense>
                                                            </a>
                                                        })
                                                    )
                                                }
                                            
                                        </div>
                                    </div>
                                    : null
                                }
                                {this.state.contactUsBlock.isEnabled ?
                                    <div className="row c-sitemap-copyright">
                                        <div className="col-xs-8 col-sm-8 col-md-7 c-logo-sitemap">
                                            <a href="https://artshouselimited.sg/" target="_blank" className="c-logo" title={COMPANY_NAME_FULL}>
                                                <Suspense fallback={null}>
                                                    <ImageLoader src={IMG_LOGO} type="image"></ImageLoader>
                                                </Suspense>
                                            </a>
                                            <div className="c-links">
                                                <a className="copyright">© {this.state.year} All Rights Reserved. Arts House Limited.</a>
                                              
                                                {/* <a href={CONTACT_US} target="_blank" rel="noreferrer">Contact us</a> */}
                                                {/* <a href={PRIVACY_POLICY} target="_blank" rel="noreferrer">Personal Data Protection Policy</a> */}
                                                {/* <a href={SITE_MAP} target="_blank" rel="noreferrer">Site Map</a>
                                                <a href={TERMS_OF_USE} target="_blank" rel="noreferrer">Terms of Use</a>
                                                <a href={PRIVACY_POLICY} target="_blank" rel="noreferrer">Privacy Policy</a> */}
                                                {/* <a href={TERMS_CONDITION} target="_blank" rel="noreferrer">Annual Report</a> */}
                                            </div>
                                        </div>
                                        <div className="col-xs-4 col-sm-4 col-md-5 powered-by">
                                            <a href={GIVEPLEASE_MICROSITE} target="_blank">
                                                <span>Powered by</span>
                                                {LOGO_GIVEPLEASE}
                                            </a>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                        :
                        <FleckringFooter></FleckringFooter>
                }
            </>
        )
    }
}

export default FooterSection;